export default __webpack_public_path__ + "static/media/bound-in-gold.ced3b018.png";